import { Typography, List, ListItem } from "@mui/material";
import { Box } from "@mui/system";

interface HelpFormattingModalContentInterface {
  includeFileTips: boolean;
}

export const HelpFormattingModalContent = ({
  includeFileTips,
}: HelpFormattingModalContentInterface) => {
  return (
    <Box>
      {includeFileTips && (
        <>
          <Typography variant="h5" sx={{ mt: 2 }}>
            File
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            File must be of CSV type. Lines are split by commas. If you'd like
            your Number Name to have a comma, please wrap the value in Double Quotes
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            The FIRST column must be the valid Phone Number, the SECOND column
            must be the new expected Number Name
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Top line of the CSV file will be assumed to be headers, and will be
            ignored when extracting data
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Example file:
            <Box
              sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              <Box className="tn" sx={{ width: "60%" }}>
                TN,Number-Name
                <br />
                5555555555,WIRELESS CALLER
                <br />
                15551234567,JOHN SMITH
                <br />
                5557654321,"WITH,COMMA"
              </Box>
            </Box>
          </Typography>
        </>
      )}
      <Typography variant="h5" sx={{ mt: 2 }}>
        Formatting Phone Numbers
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Phone Numbers can either be in E164 Format (including Leading 1), OR
        just the 10 digit number.
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Please do NOT include any spaces, dashes, parenthesises, etc. in the
        number
      </Typography>
      <Typography variant="h5" sx={{ mt: 4 }}>
        Formatting Number Names
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Number Names Must:
        <List>
          <ListItem>Be no longer than 15 characters</ListItem>
          <ListItem>
            Contain none of these characters: Double Quote (") Pipe (|),
            Non-ASCII Characters (ex: Accent marks)
          </ListItem>
        </List>
      </Typography>
    </Box>
  );
};
